// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'
import FeedView from 'js/page/Widget/components/Feed/FeedView'

import { BLOGS_LIST_WRAPPER } from './List.queries'

// First load data, otherwise useWindowScrollPosition and FeedView won't work properly
const ListWrapper = () => {
    const { data, loading } = useQuery<any>(BLOGS_LIST_WRAPPER)

    if (loading) {
        return null
    }
    return <List data={data} />
}

const List = ({ data }) => {
    const { viewer, site } = data

    const { t } = useTranslation()

    const settings = {
        showTagFilter: site?.pageTagFilters.showAllTagCategories,
        showTagCategories: site?.pageTagFilters.showTagCategories,
        sortingOptions: ['timePublished', 'lastAction', 'timeUpdated'],
        typeFilter: ['blog'],
        sortBy: 'lastAction',
        sortDirection: 'desc',
        itemView: 'list',
        itemCount: 10,
    }

    useWindowScrollPosition('blogs')

    return (
        <>
            <PageHeader
                title={t('entity-blog.name', { count: 2 })}
                canCreate={viewer && viewer.canWriteToContainer}
                createLink="/blog/add"
                createLabel={t('entity-blog.create')}
            />
            <Section>
                <Container size="tiny">
                    <FeedView guid="blogs" settings={settings} />
                </Container>
            </Section>
        </>
    )
}

export default ListWrapper
